import React, { useState, useEffect, } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { FaTimes } from 'react-icons/fa';

import './HousingForm.css';
import { api, request } from '../../../../utilities';

export default function HousingForm(props) {

  const [buildingsList, setBuildingsList] = useState([])
  const [roomTypeList, setRoomTypeList] = useState([])
  const [roomFeatureList, setRoomFeatureList] = useState([])
  const [mealPlanList, setMealPlanList] = useState([])
  const { housingType, buildingName, roomType, roomFeature, mealPlan } = props.data
  const { classification } = props.student

  useEffect(() => {
    //Component mounted
    const controller = new AbortController()
    const signal = controller.signal

    request(api('view/building'), signal, 'GET', undefined, { id: housingType, })
      .then(res => res.json())
      .then(obj => {
        setBuildingsList(obj)
        if (obj.length === 1) setChar("buildingName", obj[0]["id"])
      })
      .catch(e => console.error(e))

    request(api('view/room-type'), signal, 'GET', undefined, { housingType, buildingName })
      .then(res => res.json())
      .then(obj => {
        setRoomTypeList(obj)
        if (obj.length === 1) setChar("roomType", obj[0]["id"])
      })
      .catch(e => console.error(e))

    request(api('view/room-feature'), signal, 'GET', undefined, { housingType, buildingName, roomType })
      .then(res => res.json())
      .then(obj => {
        setRoomFeatureList(obj)
        if (obj.length === 1) setChar("roomFeature", obj[0]["id"])
      })
      .catch(e => console.error(e))

    request(api('view/meal'), signal, 'GET', undefined, { classification, buildingName })
      .then(res => res.json())
      .then(obj => {
        setMealPlanList(obj)
        if (obj.length === 1) setChar("mealPlan", obj[0]["id"])
      })
      .catch(e => console.error(e))

    return () => {
      //Component unmounted
      controller.abort()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [housingType, buildingName, roomType, classification]) // Empty dependency array to run the effect

  const setChar = (key, value, del_key = undefined) => {
    let ans = { ...props.data }
    if (value && ans[key] !== value) {
      ans[key] = value
      if (del_key !== undefined) {
        if (Array.isArray(del_key)) del_key.forEach(e => delete ans[e])
        else delete ans[del_key]
      }
      props.changeState(ans)
    }
  }
  const buildingDropdown = () => {
    return (
      <select disabled={buildingsList.length === 0} onChange={(e) => setChar("buildingName", e.target.value, "roomType")} value={buildingName} >
        <option value="">{(buildingsList.length === 0) ? 'Select a housing type to see buildings available' : 'Please select a building'}</option>
        {buildingsList.map(area => (<option key={area.id} value={area.id} >{area.name}</option>))}
      </select>
    )
  }
  const roomTypeDropdown = () => {
    return (
      <select disabled={roomTypeList.length === 0} onChange={(e) => setChar("roomType", e.target.value, "roomFeature")} value={roomType} >
        <option value="">{(roomTypeList.length === 0) ? 'Select a building to see room type available' : 'Please select a room type'}</option>
        {roomTypeList.map(area => (<option key={area.id} value={area.id} >{area.name}</option>))}
      </select>
    )
  }
  const roomFeatureDropdown = () => {
    return (
      <select disabled={roomFeatureList.length === 0} onChange={(e) => setChar("roomFeature", e.target.value)} value={roomFeature} >
        <option value="">{(roomFeatureList.length === 0) ? 'Select a room type to see room feature available' : 'Please select a room feature'}</option>
        {roomFeatureList.map(area => (<option key={area.id} value={area.id} >{area.name}</option>))}
      </select>
    )
  }
  const mealPlanDropdown = () => {
    return (
      <select disabled={mealPlanList.length === 0} onChange={(e) => setChar("mealPlan", e.target.value)} value={mealPlan} >
        <option value="">{(mealPlanList.length === 0) ? 'Select a building and classification to see meal plans available' : 'Please select a meal plan'}</option>
        {mealPlanList.map(area => (<option key={area.id} value={area.id} >{area.name}</option>))}
      </select>
    )
  }

  return (
    <Accordion defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Housing Information  {(props.invalid) ? <FaTimes style={{ marginLeft: 'auto', marginTop: "5px", color: "red" }} size={30} /> : null}</Accordion.Header>
        <Accordion.Body>
          <div className="entry btn-group mb-3" role='group'>
            <label htmlFor="housingType">Housing Type</label>
            <span id="housingType">
              <button type="button" className={housingType === 1 ? "btn active" : "btn"} onClick={() => setChar("housingType", 1, "buildingName")}>Traditional Residence Hall</button>
              <button type="button" className={housingType === 2 ? "btn active" : "btn"} onClick={() => setChar("housingType", 2, "buildingName")}>Suite Style Residence Hall</button>
              <button type="button" className={housingType === 3 ? "btn active" : "btn"} onClick={() => setChar("housingType", 3, "buildingName")}>University Apartments</button>
              <button type="button" className={housingType === 4 ? "btn active" : "btn"} onClick={() => setChar("housingType", 4, "buildingName")}>Off Campus Housing</button>
            </span>
          </div>
          <hr></hr>
          {/* living off campus, hide this */}
          <div className='container'>
            {housingType !== 4 && (
              <>
                <div className="row align-items-center mb-3">
                  <div className="col-md-3">
                    <label htmlFor="buildingName" className="form-label">Building Name</label>
                  </div>
                  <div className="col-md-9">
                    <span id="buildingName" name="buildingName" className='dropdown' >
                      {buildingDropdown()}
                    </span>
                  </div>
                </div>
                <hr />

                <div className="row align-items-center mb-3">
                  <div className="col-md-3">
                    <label htmlFor="roomType" className="form-label">Room Type</label>
                  </div>
                  <div className="col-md-9">
                    <span id="roomType" name="roomType" className='dropdown' >
                      {roomTypeDropdown()}
                    </span>
                  </div>
                </div>
                <hr />

                <div className="row align-items-center mb-3">
                  <div className="col-md-3">
                    <label htmlFor="roomFeature" className="form-label">Room Feature</label>
                  </div>
                  <div className="col-md-9">
                    <span id="roomFeature" name="roomFeature" className='dropdown' >
                      {roomFeatureDropdown()}
                    </span>
                  </div>
                </div>
                <hr />
              </>
            )}

            <div className="row align-items-center mb-3">
              <div className="col-md-3">
                <label htmlFor="mealPlan" className="form-label">Meal Plan</label>
              </div>
              <div className="col-md-9">
                <span id="mealPlan" name="mealPlan" className='dropdown' >
                  {mealPlanDropdown()}
                </span>
              </div>
            </div>
          </div>

        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}